import React from 'react';
import {useIntl} from 'react-intl';
import ErrorPage from '../../common/ErrorPage/ErrorPage';
import PageTitle from '../PageTitle';
import {SESSION_EXPIRED_KEY, SESSION_EXPIRED_TITLE_KEY} from './constants';
import {useIsDashboardLinkVisible} from './hooks/useIsDashboardLinkVisible';

export function SessionExpired() {
    const intl = useIntl();
    const isDashboardLinkVisible = useIsDashboardLinkVisible();

    const titleKey = SESSION_EXPIRED_TITLE_KEY;
    const messageKey = SESSION_EXPIRED_KEY;

    const customTitleMessage = intl.formatMessage({id: titleKey, defaultMessage: 'Session Expired'});
    const customErrorMessage = intl.formatMessage({id: messageKey, defaultMessage: 'Your session has expired'});

    return (
        <>
            <PageTitle pageTitle={customTitleMessage} />
            <ErrorPage
                isDashboardLinkVisible={isDashboardLinkVisible}
                customTitleMessage={customTitleMessage}
                customErrorMessage={customErrorMessage}
            />
        </>
    );
}
